import * as React from 'react';
import { observer } from 'mobx-react';
import { DocumentsImagesStoreAbstract } from '@shared/documents-images/DocumentsImagesStoreAbstract';
import { DocumentsSettingsDropdown } from '@shared/documents-images/ui/DocumentsSettingsDropdown';
import { Button } from '@shared/ui-react/Button';
import { Events, EventsGlobal } from '@shared/Events';
import { Telemetry, TelemetryEventType, TelemetrySource } from '@shared/Telemetry';

@observer
export class DocumentsPanelToolbar extends React.Component<{
    store: DocumentsImagesStoreAbstract<any>;
    openCreateExternal: () => void;
    openFillTemplate: () => void;
}> {
    render() {
        return (
            <>
                <Button
                    secondary
                    subtle
                    icon='iki-fit-to-screen'
                    style={{ marginLeft: 'auto' }}
                    onClick={() => {
                        Events.trigger(EventsGlobal.MAP_FIT_DOCUMENTS);
                        Telemetry.add(TelemetryEventType.MAP_DOCS_FIT_VIEW, TelemetrySource.MAP_2D_DESKTOP);
                    }}
                    title={__('js_map.fit_visible')}
                />
                <DocumentsSettingsDropdown store={this.props.store} openCreateExternal={this.props.openCreateExternal} openFillTemplate={this.props.openFillTemplate} />
            </>
        );
    }
}
